var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "transition",
    {
      attrs: { name: _vm.transitionName },
      on: { "after-leave": _vm.handleAfterLeave },
    },
    [
      _c(
        "div",
        {
          directives: [
            {
              name: "show",
              rawName: "v-show",
              value: _vm.visible,
              expression: "visible",
            },
          ],
          class: ["v-notification", `v-notification--${_vm.position}`],
          style: _vm.positionStyle,
          on: { mouseenter: _vm.clearTimer, mouseleave: _vm.startTimer },
        },
        [
          _c("div", { staticClass: "v-notification__header" }, [
            _vm.title
              ? _c(
                  "h5",
                  {
                    class: [
                      `v-notification__title`,
                      { "v-notification__close-space": _vm.showClose },
                    ],
                  },
                  [_vm._v(" " + _vm._s(_vm.title) + " ")]
                )
              : _vm._e(),
          ]),
          _c(
            "div",
            { staticClass: "v-notification__main" },
            [
              !_vm.dangerouslyUseHTMLString
                ? [
                    _c(
                      "p",
                      {
                        class: [
                          `v-notification__main--default`,
                          {
                            "v-notification__close-space":
                              _vm.showClose && !_vm.title,
                          },
                        ],
                      },
                      [_vm._v(" " + _vm._s(_vm.content) + " ")]
                    ),
                  ]
                : [_c("div", { domProps: { innerHTML: _vm._s(_vm.content) } })],
            ],
            2
          ),
          _vm.showConfirm
            ? _c(
                "div",
                { staticClass: "v-notification__button" },
                [
                  _c(
                    "v-button",
                    {
                      staticClass: "v-notification__button-confirm",
                      attrs: { type: "primary", size: "M" },
                      on: { click: _vm.close },
                    },
                    [_vm._v(_vm._s(_vm.confirmText))]
                  ),
                ],
                1
              )
            : _vm._e(),
          _vm.showClose
            ? _c("div", {
                staticClass: "v-icon-close v-notification__close",
                on: { click: _vm.close },
              })
            : _vm._e(),
        ]
      ),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }